/**
 * LB3 ("Wardrobe Mix") state resolver.
 *
 * Pure function — no rendering, no side-effects. Drives which Lb3Card
 * variant to render and gates the generate-lookbook3 client call.
 *
 * - "guest"            → not signed in. Show signup CTA (lb3_guest_cta).
 * - "auth-empty"       → signed in, fewer than LB3_WARDROBE_THRESHOLD eligible
 *                        wardrobe items. Show "Add wardrobe" CTA pointing to
 *                        the wardrobe tab.
 * - "auth-ready"       → signed in with enough eligible items. Generate /
 *                        display the real LB3 image.
 *
 * The threshold is intentionally re-stated here (matches the client-side
 * gate raised in Phase 2A) so the resolver is self-contained for tests.
 * Keep in sync with the >= 3 check at the LB3 call sites in index.tsx.
 */

export const LB3_WARDROBE_THRESHOLD = 3;

export type Lb3State = "guest" | "auth-empty" | "auth-ready";

export interface ResolveLb3StateInput {
  isGuest: boolean;
  wardrobeEligibleCount: number;
}

export function resolveLb3State({
  isGuest,
  wardrobeEligibleCount,
}: ResolveLb3StateInput): Lb3State {
  if (isGuest) return "guest";
  if (wardrobeEligibleCount < LB3_WARDROBE_THRESHOLD) return "auth-empty";
  return "auth-ready";
}
